import { getIconSize } from '../SvgIcon/getIconSize';
const mdIconButtonPaddingPx = 8;
/**
 * Gets ActionIcon's height in pixels by inner svg icon size.
 *
 * May be used, for example, to determine the minimum height of table row, so the row's height to be equal other rows.
 */
export function getActionIconHeightBySize(size) {
    return Number(getIconSize(size, (pixel) => pixel.toString())) + mdIconButtonPaddingPx * 2;
}
